import PrimerAssemblyTabState from 'assembly/tabs/primer-assembly/backbone/PrimerAssemblyTabState';

class GibsonTabState extends PrimerAssemblyTabState {}

export default GibsonTabState;
